export var countries = [
    {value: 'AT', text: 'AUSTRIA'},
    {value: 'DE', text: 'GERMANY'},
    {value: 'CH', text: 'SWITZERLAND'},
    {value: '-1', text: '--'},
    {value: 'AF', text: 'AFGHANISTAN'},
    {value: 'AX', text: 'ÅLAND ISLANDS'},
    {value: 'AL', text: 'ALBANIA'},
    {value: 'DZ', text: 'ALGERIA'},
    {value: 'AS', text: 'AMERICAN SAMOA'},
    {value: 'AD', text: 'ANDORRA'},
    {value: 'AO', text: 'ANGOLA'},
    {value: 'AI', text: 'ANGUILLA'},
    {value: 'AQ', text: 'ANTARCTICA'},
    {value: 'AG', text: 'ANTIGUA AND BARBUDA'},
    {value: 'AR', text: 'ARGENTINA'},
    {value: 'AM', text: 'ARMENIA'},
    {value: 'AW', text: 'ARUBA'},
    {value: 'AU', text: 'AUSTRALIA'},
    {value: 'AZ', text: 'AZERBAIJAN'},
    {value: 'BS', text: 'BAHAMAS'},
    {value: 'BH', text: 'BAHRAIN'},
    {value: 'BD', text: 'BANGLADESH'},
    {value: 'BB', text: 'BARBADOS'},
    {value: 'BY', text: 'BELARUS'},
    {value: 'BE', text: 'BELGIUM'},
    {value: 'BZ', text: 'BELIZE'},
    {value: 'BJ', text: 'BENIN'},
    {value: 'BM', text: 'BERMUDA'},
    {value: 'BT', text: 'BHUTAN'},
    {value: 'BO', text: 'BOLIVIA, PLURINATIONAL STATE OF'},
    {value: 'BQ', text: 'BONAIRE, SINT EUSTATIUS AND SABA'},
    {value: 'BA', text: 'BOSNIA AND HERZEGOVINA'},
    {value: 'BW', text: 'BOTSWANA'},
    {value: 'BV', text: 'BOUVET ISLAND'},
    {value: 'BR', text: 'BRAZIL'},
    {value: 'IO', text: 'BRITISH INDIAN OCEAN TERRITORY'},
    {value: 'BN', text: 'BRUNEI DARUSSALAM'},
    {value: 'BG', text: 'BULGARIA'},
    {value: 'BF', text: 'BURKINA FASO'},
    {value: 'BI', text: 'BURUNDI'},
    {value: 'KH', text: 'CAMBODIA'},
    {value: 'CM', text: 'CAMEROON'},
    {value: 'CA', text: 'CANADA'},
    {value: 'CV', text: 'CAPE VERDE'},
    {value: 'KY', text: 'CAYMAN ISLANDS'},
    {value: 'CF', text: 'CENTRAL AFRICAN REPUBLIC'},
    {value: 'TD', text: 'CHAD'},
    {value: 'CL', text: 'CHILE'},
    {value: 'CN', text: 'CHINA'},
    {value: 'CX', text: 'CHRISTMAS ISLAND'},
    {value: 'CC', text: 'COCOS (KEELING) ISLANDS'},
    {value: 'CO', text: 'COLOMBIA'},
    {value: 'KM', text: 'COMOROS'},
    {value: 'CG', text: 'CONGO'},
    {value: 'CD', text: 'CONGO, THE DEMOCRATIC REPUBLIC OF THE'},
    {value: 'CK', text: 'COOK ISLANDS'},
    {value: 'CR', text: 'COSTA RICA'},
    {value: 'CI', text: 'CÔTE D\'IVOIRE'},
    {value: 'HR', text: 'CROATIA'},
    {value: 'CU', text: 'CUBA'},
    {value: 'CW', text: 'CURAÇAO'},
    {value: 'CY', text: 'CYPRUS'},
    {value: 'CZ', text: 'CZECH REPUBLIC'},
    {value: 'DK', text: 'DENMARK'},
    {value: 'DJ', text: 'DJIBOUTI'},
    {value: 'DM', text: 'DOMINICA'},
    {value: 'DO', text: 'DOMINICAN REPUBLIC'},
    {value: 'EC', text: 'ECUADOR'},
    {value: 'EG', text: 'EGYPT'},
    {value: 'SV', text: 'EL SALVADOR'},
    {value: 'GQ', text: 'EQUATORIAL GUINEA'},
    {value: 'ER', text: 'ERITREA'},
    {value: 'EE', text: 'ESTONIA'},
    {value: 'ET', text: 'ETHIOPIA'},
    {value: 'FK', text: 'FALKLAND ISLANDS (MALVINAS)'},
    {value: 'FO', text: 'FAROE ISLANDS'},
    {value: 'FJ', text: 'FIJI'},
    {value: 'FI', text: 'FINLAND'},
    {value: 'FR', text: 'FRANCE'},
    {value: 'GF', text: 'FRENCH GUIANA'},
    {value: 'PF', text: 'FRENCH POLYNESIA'},
    {value: 'TF', text: 'FRENCH SOUTHERN TERRITORIES'},
    {value: 'GA', text: 'GABON'},
    {value: 'GM', text: 'GAMBIA'},
    {value: 'GE', text: 'GEORGIA'},
    {value: 'GH', text: 'GHANA'},
    {value: 'GI', text: 'GIBRALTAR'},
    {value: 'GR', text: 'GREECE'},
    {value: 'GL', text: 'GREENLAND'},
    {value: 'GD', text: 'GRENADA'},
    {value: 'GP', text: 'GUADELOUPE'},
    {value: 'GU', text: 'GUAM'},
    {value: 'GT', text: 'GUATEMALA'},
    {value: 'GG', text: 'GUERNSEY'},
    {value: 'GN', text: 'GUINEA'},
    {value: 'GW', text: 'GUINEA-BISSAU'},
    {value: 'GY', text: 'GUYANA'},
    {value: 'HT', text: 'HAITI'},
    {value: 'HM', text: 'HEARD ISLAND AND MCDONALD ISLANDS'},
    {value: 'VA', text: 'HOLY SEE (VATICAN CITY STATE)'},
    {value: 'HN', text: 'HONDURAS'},
    {value: 'HK', text: 'HONG KONG'},
    {value: 'HU', text: 'HUNGARY'},
    {value: 'IS', text: 'ICELAND'},
    {value: 'IN', text: 'INDIA'},
    {value: 'ID', text: 'INDONESIA'},
    {value: 'IR', text: 'IRAN, ISLAMIC REPUBLIC OF'},
    {value: 'IQ', text: 'IRAQ'},
    {value: 'IE', text: 'IRELAND'},
    {value: 'IM', text: 'ISLE OF MAN'},
    {value: 'IL', text: 'ISRAEL'},
    {value: 'IT', text: 'ITALY'},
    {value: 'JM', text: 'JAMAICA'},
    {value: 'JP', text: 'JAPAN'},
    {value: 'JE', text: 'JERSEY'},
    {value: 'JO', text: 'JORDAN'},
    {value: 'KZ', text: 'KAZAKHSTAN'},
    {value: 'KE', text: 'KENYA'},
    {value: 'KI', text: 'KIRIBATI'},
    {value: 'KP', text: 'KOREA, DEMOCRATIC PEOPLE\'S REPUBLIC OF'},
    {value: 'KR', text: 'KOREA, REPUBLIC OF'},
    {value: 'KW', text: 'KUWAIT'},
    {value: 'KG', text: 'KYRGYZSTAN'},
    {value: 'LA', text: 'LAO PEOPLE\'S DEMOCRATIC REPUBLIC'},
    {value: 'LV', text: 'LATVIA'},
    {value: 'LB', text: 'LEBANON'},
    {value: 'LS', text: 'LESOTHO'},
    {value: 'LR', text: 'LIBERIA'},
    {value: 'LY', text: 'LIBYA'},
    {value: 'LI', text: 'LIECHTENSTEIN'},
    {value: 'LT', text: 'LITHUANIA'},
    {value: 'LU', text: 'LUXEMBOURG'},
    {value: 'MO', text: 'MACAO'},
    {value: 'MK', text: 'MACEDONIA, THE FORMER YUGOSLAV REPUBLIC OF'},
    {value: 'MG', text: 'MADAGASCAR'},
    {value: 'MW', text: 'MALAWI'},
    {value: 'MY', text: 'MALAYSIA'},
    {value: 'MV', text: 'MALDIVES'},
    {value: 'ML', text: 'MALI'},
    {value: 'MT', text: 'MALTA'},
    {value: 'MH', text: 'MARSHALL ISLANDS'},
    {value: 'MQ', text: 'MARTINIQUE'},
    {value: 'MR', text: 'MAURITANIA'},
    {value: 'MU', text: 'MAURITIUS'},
    {value: 'YT', text: 'MAYOTTE'},
    {value: 'MX', text: 'MEXICO'},
    {value: 'FM', text: 'MICRONESIA, FEDERATED STATES OF'},
    {value: 'MD', text: 'MOLDOVA, REPUBLIC OF'},
    {value: 'MC', text: 'MONACO'},
    {value: 'MN', text: 'MONGOLIA'},
    {value: 'ME', text: 'MONTENEGRO'},
    {value: 'MS', text: 'MONTSERRAT'},
    {value: 'MA', text: 'MOROCCO'},
    {value: 'MZ', text: 'MOZAMBIQUE'},
    {value: 'MM', text: 'MYANMAR'},
    {value: 'NA', text: 'NAMIBIA'},
    {value: 'NR', text: 'NAURU'},
    {value: 'NP', text: 'NEPAL'},
    {value: 'NL', text: 'NETHERLANDS'},
    {value: 'NC', text: 'NEW CALEDONIA'},
    {value: 'NZ', text: 'NEW ZEALAND'},
    {value: 'NI', text: 'NICARAGUA'},
    {value: 'NE', text: 'NIGER'},
    {value: 'NG', text: 'NIGERIA'},
    {value: 'NU', text: 'NIUE'},
    {value: 'NF', text: 'NORFOLK ISLAND'},
    {value: 'MP', text: 'NORTHERN MARIANA ISLANDS'},
    {value: 'NO', text: 'NORWAY'},
    {value: 'OM', text: 'OMAN'},
    {value: 'PK', text: 'PAKISTAN'},
    {value: 'PW', text: 'PALAU'},
    {value: 'PS', text: 'PALESTINIAN TERRITORY, OCCUPIED'},
    {value: 'PA', text: 'PANAMA'},
    {value: 'PG', text: 'PAPUA NEW GUINEA'},
    {value: 'PY', text: 'PARAGUAY'},
    {value: 'PE', text: 'PERU'},
    {value: 'PH', text: 'PHILIPPINES'},
    {value: 'PN', text: 'PITCAIRN'},
    {value: 'PL', text: 'POLAND'},
    {value: 'PT', text: 'PORTUGAL'},
    {value: 'PR', text: 'PUERTO RICO'},
    {value: 'QA', text: 'QATAR'},
    {value: 'RE', text: 'RÉUNION'},
    {value: 'RO', text: 'ROMANIA'},
    {value: 'RU', text: 'RUSSIAN FEDERATION'},
    {value: 'RW', text: 'RWANDA'},
    {value: 'BL', text: 'SAINT BARTHÉLEMY'},
    {value: 'SH', text: 'SAINT HELENA, ASCENSION AND TRISTAN DA CUNHA'},
    {value: 'KN', text: 'SAINT KITTS AND NEVIS'},
    {value: 'LC', text: 'SAINT LUCIA'},
    {value: 'MF', text: 'SAINT MARTIN (FRENCH PART)'},
    {value: 'PM', text: 'SAINT PIERRE AND MIQUELON'},
    {value: 'VC', text: 'SAINT VINCENT AND THE GRENADINES'},
    {value: 'WS', text: 'SAMOA'},
    {value: 'SM', text: 'SAN MARINO'},
    {value: 'ST', text: 'SAO TOME AND PRINCIPE'},
    {value: 'SA', text: 'SAUDI ARABIA'},
    {value: 'SN', text: 'SENEGAL'},
    {value: 'RS', text: 'SERBIA'},
    {value: 'SC', text: 'SEYCHELLES'},
    {value: 'SL', text: 'SIERRA LEONE'},
    {value: 'SG', text: 'SINGAPORE'},
    {value: 'SX', text: 'SINT MAARTEN (DUTCH PART)'},
    {value: 'SK', text: 'SLOVAKIA'},
    {value: 'SI', text: 'SLOVENIA'},
    {value: 'SB', text: 'SOLOMON ISLANDS'},
    {value: 'SO', text: 'SOMALIA'},
    {value: 'ZA', text: 'SOUTH AFRICA'},
    {value: 'GS', text: 'SOUTH GEORGIA AND THE SOUTH SANDWICH ISLANDS'},
    {value: 'SS', text: 'SOUTH SUDAN'},
    {value: 'ES', text: 'SPAIN'},
    {value: 'LK', text: 'SRI LANKA'},
    {value: 'SD', text: 'SUDAN'},
    {value: 'SR', text: 'SURINAME'},
    {value: 'SJ', text: 'SVALBARD AND JAN MAYEN'},
    {value: 'SZ', text: 'SWAZILAND'},
    {value: 'SE', text: 'SWEDEN'},
    {value: 'SY', text: 'SYRIAN ARAB REPUBLIC'},
    {value: 'TW', text: 'TAIWAN, PROVINCE OF CHINA'},
    {value: 'TJ', text: 'TAJIKISTAN'},
    {value: 'TZ', text: 'TANZANIA, UNITED REPUBLIC OF'},
    {value: 'TH', text: 'THAILAND'},
    {value: 'TL', text: 'TIMOR-LESTE'},
    {value: 'TG', text: 'TOGO'},
    {value: 'TK', text: 'TOKELAU'},
    {value: 'TO', text: 'TONGA'},
    {value: 'TT', text: 'TRINIDAD AND TOBAGO'},
    {value: 'TN', text: 'TUNISIA'},
    {value: 'TR', text: 'TURKEY'},
    {value: 'TM', text: 'TURKMENISTAN'},
    {value: 'TC', text: 'TURKS AND CAICOS ISLANDS'},
    {value: 'TV', text: 'TUVALU'},
    {value: 'UG', text: 'UGANDA'},
    {value: 'UA', text: 'UKRAINE'},
    {value: 'AE', text: 'UNITED ARAB EMIRATES'},
    {value: 'GB', text: 'UNITED KINGDOM'},
    {value: 'US', text: 'UNITED STATES'},
    {value: 'UM', text: 'UNITED STATES MINOR OUTLYING ISLANDS'},
    {value: 'UY', text: 'URUGUAY'},
    {value: 'UZ', text: 'UZBEKISTAN'},
    {value: 'VU', text: 'VANUATU'},
    {value: 'VE', text: 'VENEZUELA, BOLIVARIAN REPUBLIC OF'},
    {value: 'VN', text: 'VIET NAM'},
    {value: 'VG', text: 'VIRGIN ISLANDS, BRITISH'},
    {value: 'VI', text: 'VIRGIN ISLANDS, U.S.'},
    {value: 'WF', text: 'WALLIS AND FUTUNA'},
    {value: 'EH', text: 'WESTERN SAHARA'},
    {value: 'YE', text: 'YEMEN'},
    {value: 'ZM', text: 'ZAMBIA'},
    {value: 'ZW', text: 'ZIMBABWE'}
]


// WEBPACK FOOTER //
// ./src/app/data/countries.ts